var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmoke(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_842_523)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M29.5625 30.9063C29.5625 26.3882 30.9023 21.9716 33.4124 18.215C35.9225 14.4583 39.4902 11.5304 43.6643 9.80139C47.8385 8.0724 52.4316 7.62002 56.8629 8.50145C61.2941 9.38288 65.3645 11.5585 68.5592 14.7533C71.754 17.948 73.9296 22.0184 74.8111 26.4497C75.6925 30.8809 75.2401 35.474 73.5111 39.6482C71.7822 43.8223 68.8542 47.39 65.0976 49.9001C61.3409 52.4103 56.9243 53.75 52.4063 53.75H25.5313C21.611 53.75 17.8514 52.1927 15.0793 49.4207C12.3073 46.6487 10.75 42.889 10.75 38.9688C10.75 35.0485 12.3073 31.2889 15.0793 28.5168C17.8514 25.7448 21.611 24.1875 25.5313 24.1875C27.1669 24.1791 28.7919 24.4518 30.3352 24.9938",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3125 64.5H13.1875",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.125 64.5H64",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8125 64.5H42.75",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.75 75.25H17.9375",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8125 75.25H51",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5625 30.9063C29.5625 26.3882 30.9023 21.9716 33.4124 18.215C35.9225 14.4583 39.4902 11.5304 43.6643 9.80139C47.8385 8.0724 52.4316 7.62002 56.8629 8.50145C61.2941 9.38288 65.3645 11.5585 68.5592 14.7533C71.754 17.948 73.9297 22.0184 74.8111 26.4497C75.6925 30.8809 75.2401 35.474 73.5111 39.6482C71.7822 43.8223 68.8542 47.39 65.0976 49.9001C61.3409 52.4103 56.9243 53.75 52.4063 53.75H25.5313C21.611 53.75 17.8514 52.1927 15.0793 49.4207C12.3073 46.6487 10.75 42.889 10.75 38.9688C10.75 35.0485 12.3073 31.2889 15.0793 28.5168C17.8514 25.7448 21.611 24.1875 25.5313 24.1875C27.1669 24.1791 28.7919 24.4518 30.3352 24.9938",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_842_523"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 86,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmoke);
export default __webpack_public_path__ + "static/media/smoke.3498bd5472d27c38045c6d44bca94acc.svg";
export { ForwardRef as ReactComponent };